import { DataFormField } from "types/models/input-field-type";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { convertIosStringToDate } from "helper/common";

const { DATE, NUMBER, INPUT, SELECT, TEXT_AREA, AUTO_COMPLETE, COMBO_BOX } =
  FIELD_TYPE;

const cssProps = {
  labelCol: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
  wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 18 },
  css: { xs: 24, sm: 24, md: 12, lg: 12, xl: 12 },
};

const cssProps2 = {
  labelCol: { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 },
  wrapperCol: { xs: 22, sm: 22, md: 22, lg: 22, xl: 22 },
  css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
};
const cssProps3 = {
  labelCol: { xs: 2, sm: 2, md: 2, lg: 4, xl: 4 },
  wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24, xl: 20 },
  css: { xs: 24, sm: 24, md: 16, lg: 12, xl: 12 },
};

const dataFieldsMap = () => {
  return [
    {
      name: "idBenhNhan",
      type: INPUT,
      label: "Mã bệnh nhân",
      disable: true,
      ...cssProps,
    },
    {
      name: "hoTen",
      type: INPUT,
      label: "Họ và tên",
      disable: true,
      ...cssProps,
    },
    {
      name: "tenLoaiThe",
      type: INPUT,
      disable: true,
      label: "Loại thẻ",
      ...cssProps,
    },
    {
      name: "ngayPhatHanh",
      type: DATE,
      label: "Ngày phát hành",
      disable: true,
      ...cssProps,
    },
    {
      name: "hetHan",
      type: DATE,
      label: "Ngày hết hiệu lực",
      disable: true,
      ...cssProps,
    },
    {
      name: "nguoiBan",
      type: COMBO_BOX,
      label: "Người bán thẻ",
      disable: true,
      placeholder: "",
      ...cssProps,
    },
    {
      name: "hinhThucThanhToan",
      type: SELECT,
      label: "Hình thức TT",
      disable: true,
      placeholder: "",
      options: [
        { value: 0, label: "Tiền mặt" },
        { value: 1, label: "Chuyển khoản" },
        { value: 2, label: "Quẹt thẻ" },
      ],
      ...cssProps,
    },
  ];
};

const historyColumns: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (v, r, i) => i + 1,
    align: "center",
  },
  {
    title: "Dịch vụ",
    dataIndex: "tenDichVu",
    key: "tenDichVu",
    align: "left",
  },
  {
    title: "Số lần hưởng",
    dataIndex: "soLanBanDau",
    key: "soLanBanDau",
    align: "right",
  },
  {
    title: "Số lần đã dùng",
    dataIndex: "soLanSuDung",
    key: "soLanDaDung",
    align: "right",
  },
  {
    title: "Số lần còn lại",
    dataIndex: "soLanConLai",
    key: "soLanConLai",
    align: "right",
  },
  // {
  //   title: "Thời gian sử dụng",
  //   dataIndex: "lichSus",
  //   key: "lichSus",
  //   align: "right"
  // },
];

export { dataFieldsMap, historyColumns };
